/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteSnapshot200
} from './model/deleteSnapshot200.js';

import type {
  Snapshot
} from './model/snapshot.js';

import type {
  SnapshotStatusResponse
} from './model/snapshotStatusResponse.js';

import type {
  UpdateSnapshotBody
} from './model/updateSnapshotBody.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the snapshots in the active organization.
 */
export const listSnapshots = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Snapshot[]>(
      {url: `/snapshots`, method: 'GET', signal
    },
      options);
    }




export const getListSnapshotsQueryKey = () => {
    return [
    `/snapshots`
    ] as const;
    }


export const getListSnapshotsQueryOptions = <TData = Awaited<ReturnType<typeof listSnapshots>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSnapshots>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSnapshotsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSnapshots>>> = ({ signal }) => listSnapshots(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSnapshots>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSnapshotsQueryResult = NonNullable<Awaited<ReturnType<typeof listSnapshots>>>
export type ListSnapshotsQueryError = unknown


/**
 * @summary List the snapshots in the active organization.
 */

export function useListSnapshots<TData = Awaited<ReturnType<typeof listSnapshots>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSnapshots>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSnapshotsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update a snapshot's name or commit message.
 */
export const updateSnapshot = (
    id: string,
    updateSnapshotBody: UpdateSnapshotBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Snapshot>(
      {url: `/snapshots/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSnapshotBody, signal
    },
      options);
    }




export const getUpdateSnapshotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSnapshot>>, TError,{id: string;data: UpdateSnapshotBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSnapshot>>, TError,{id: string;data: UpdateSnapshotBody}, TContext> => {

const mutationKey = ['updateSnapshot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSnapshot>>, {id: string;data: UpdateSnapshotBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSnapshot(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof updateSnapshot>>>
    export type UpdateSnapshotMutationBody = UpdateSnapshotBody
    export type UpdateSnapshotMutationError = unknown

    /**
 * @summary Update a snapshot's name or commit message.
 */
export const useUpdateSnapshot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSnapshot>>, TError,{id: string;data: UpdateSnapshotBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSnapshot>>,
        TError,
        {id: string;data: UpdateSnapshotBody},
        TContext
      > => {
      return useMutation(getUpdateSnapshotMutationOptions(options));
    }
    /**
 * @summary Delete a snapshot.
 */
export const deleteSnapshot = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<DeleteSnapshot200>(
      {url: `/snapshots/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSnapshotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSnapshot>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSnapshot>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSnapshot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSnapshot>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSnapshot(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSnapshot>>>

    export type DeleteSnapshotMutationError = unknown

    /**
 * @summary Delete a snapshot.
 */
export const useDeleteSnapshot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSnapshot>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSnapshot>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteSnapshotMutationOptions(options));
    }
    /**
 * @summary Check the progress of a snapshot capture.
 */
export const getSnapshotStatus = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<SnapshotStatusResponse>(
      {url: `/snapshots/${encodeURIComponent(String(id))}/status`, method: 'GET', signal
    },
      options);
    }




export const getGetSnapshotStatusQueryKey = (id: string,) => {
    return [
    `/snapshots/${id}/status`
    ] as const;
    }


export const getGetSnapshotStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSnapshotStatus>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSnapshotStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSnapshotStatusQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnapshotStatus>>> = ({ signal }) => getSnapshotStatus(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSnapshotStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSnapshotStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSnapshotStatus>>>
export type GetSnapshotStatusQueryError = unknown


/**
 * @summary Check the progress of a snapshot capture.
 */

export function useGetSnapshotStatus<TData = Awaited<ReturnType<typeof getSnapshotStatus>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSnapshotStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSnapshotStatusQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






